import invert from './invert.js';
import escapeMap from './_escapeMap.js';

// Internal list of HTML entities for unescaping.
export default invert(escapeMap);



//////////////////
// WEBPACK FOOTER
// /Users/gengis/Documents/WORK/_LOCAL_MAMP/genethon-2020/web/app/themes/genethon/node_modules/underscore/modules/_unescapeMap.js
// module id = 124
// module chunks = 0